import { List, Radio, RadioList, Text } from "@ucl/react-library";
import { useTranslation } from "react-i18next";
import { SelectTile } from "../select-tile/select-tile";
import { useBoundInput } from "src/hooks/use-bound-input";
import { useFormContext } from "react-hook-form";
import { ImportantInformation } from "../important-information/important-information";
import { DontWantToChallenge } from "../dont-want-to-challenge/dont-want-to-challenge";

export const ConfirmChallenge = () => {
  const { t } = useTranslation("translation", { keyPrefix: "confirmChallenge" });
  const { t: genericT } = useTranslation();
  const { control, watch } = useFormContext();

  const bullets = t("whatNextBullets", { returnObjects: true });

  const challengeDecisionProps = useBoundInput({
    name: "challengeDecision",
    control,
  });

  const challengeDecision = watch("challengeDecision");

  const showDontWantToChallenge = challengeDecision === "no-challenge";

  return (
    <div className="flex flex-col gap-10" data-testid="confirmChallengeComponent">
      <div className="flex flex-col gap-4">
        <Text renderAs="h2" styleType="h4" fontWeight="semi-bold">
          {t("step2Title")}
        </Text>

        <Text.P size="large">{t("step2Para1")}</Text.P>

        <Text.P size="large" fontWeight="semi-bold">
          {t("whatNext")}
        </Text.P>
        <List type="none">
          {Array.isArray(bullets) &&
            bullets.map((bullet) => (
              <List.Item key={bullet}><Text.P size={"large"}>{bullet}</Text.P></List.Item>
            ))}
        </List>
        <Text.P size="large">{t("whatNextUploadInfo")}</Text.P>
      </div>

      <div className="flex flex-col gap-5">
        <Text renderAs="h2" styleType="h4" fontWeight="semi-bold">
          {t("confirmChallenge")}
        </Text>

        <RadioList variant="tile" size="large" {...challengeDecisionProps}>
          <Radio
            label={t("challengeRadio")}
            value="challenge"
            className="flex flex-col-reverse !items-start"
            data-testid="challengeRadio"
          >
            <SelectTile
              title={t("challengeTitle")}
            />
          </Radio>

          <Radio
            label={t("noChallengeRadio")}
            value="no-challenge"
            className="flex flex-col-reverse !items-start"
            data-testid="noChallengeRadio"
          >
            <SelectTile title={t("noChallengeTitle")} />
          </Radio>
        </RadioList>
      </div>

      {showDontWantToChallenge ? (
        <DontWantToChallenge />
      ) : (
        <div className="flex flex-col gap-5">
          <Text renderAs="h3" styleType="h4" fontWeight="semi-bold">
            {genericT("importantInformation.title")}
          </Text>

          <ImportantInformation showOptInInfo={false} />
        </div>
      )}
    </div>
  );
};
